"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NationDetails = exports.DefaultNationData = exports.NationalLevel = void 0;
exports.getNationData = getNationData;
exports.calculateNationalBonus = calculateNationalBonus;
const nations_1 = require("./nations");
const playerTraits_1 = require("./playerTraits");
var NationalLevel;
(function (NationalLevel) {
    NationalLevel["BASIC"] = "BASIC";
    NationalLevel["HERO"] = "HERO";
    NationalLevel["ICON"] = "ICON";
})(NationalLevel || (exports.NationalLevel = NationalLevel = {}));
exports.DefaultNationData = {
    favoredOpponent: [nations_1.Nations.KOREA_NORTH],
    nationalTrait: playerTraits_1.PlayerTraits.POWERFUL,
    bonusStat: { block: 1 },
};
exports.NationDetails = {
    // UK & Ireland Region
    [nations_1.Nations.ENGLAND]: {
        favoredOpponent: [nations_1.Nations.GERMANY, nations_1.Nations.WALES], // Main: Germany, Regional: Scotland (Doc Verified)
        nationalTrait: playerTraits_1.PlayerTraits.LONG_BALL,
        bonusStat: { tackle: 1 },
    },
    [nations_1.Nations.SCOTLAND]: {
        favoredOpponent: [nations_1.Nations.ENGLAND, nations_1.Nations.SPAIN], // Main: England, Regional: Ireland (Doc Verified)
        nationalTrait: playerTraits_1.PlayerTraits.UNDERDOG,
        bonusStat: { tackle: 1 },
    },
    [nations_1.Nations.WALES]: {
        favoredOpponent: [nations_1.Nations.BELGIUM, nations_1.Nations.SCOTLAND], // Main: Belgium, Regional: England (Doc Verified)
        nationalTrait: playerTraits_1.PlayerTraits.UNDERDOG,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.IRELAND]: {
        favoredOpponent: [nations_1.Nations.ITALY, nations_1.Nations.ENGLAND], // Main: Italy, Regional: Northern Ireland (Doc Verified)
        nationalTrait: playerTraits_1.PlayerTraits.LUCKY,
        bonusStat: { tackle: 1 },
    },
    [nations_1.Nations.NORTHERN_IRELAND]: {
        favoredOpponent: [nations_1.Nations.SPAIN, nations_1.Nations.WALES], // Main: Spain, Regional: Wales (Doc Verified)
        nationalTrait: playerTraits_1.PlayerTraits.UNYIELDING,
        bonusStat: { block: 1 },
    },
    // Western & Central Europe Region
    [nations_1.Nations.GERMANY]: {
        favoredOpponent: [nations_1.Nations.BRAZIL, nations_1.Nations.FRANCE], // Main: Brazil, Regional: Netherlands (Doc Verified)
        nationalTrait: playerTraits_1.PlayerTraits.RELIABLE,
        bonusStat: { shoot: 1 },
    },
    [nations_1.Nations.FRANCE]: {
        favoredOpponent: [nations_1.Nations.BRAZIL, nations_1.Nations.BELGIUM], // Main: Brazil, Regional: Germany (Doc Verified)
        nationalTrait: playerTraits_1.PlayerTraits.DOMINANT,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.NETHERLANDS]: {
        favoredOpponent: [nations_1.Nations.ARGENTINA, nations_1.Nations.GERMANY], // Main: Germany, Regional: Belgium (Doc Verified)
        nationalTrait: playerTraits_1.PlayerTraits.PLAYMAKER,
        bonusStat: { pass: 1 },
    },
    [nations_1.Nations.BELGIUM]: {
        favoredOpponent: [nations_1.Nations.NETHERLANDS, nations_1.Nations.BRAZIL], // Main: Netherlands, Regional: France (Doc Verified)
        nationalTrait: playerTraits_1.PlayerTraits.PLAYMAKER,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.CZECH_REPUBLIC]: {
        favoredOpponent: [nations_1.Nations.NETHERLANDS, nations_1.Nations.GERMANY], // Main: Netherlands, Regional: Germany (Doc Verified) - CODE CORRECTED
        nationalTrait: playerTraits_1.PlayerTraits.UNDERDOG,
        bonusStat: { shoot: 1 },
    },
    [nations_1.Nations.POLAND]: {
        favoredOpponent: [nations_1.Nations.PORTUGAL, nations_1.Nations.GERMANY], // Main: Portugal, Regional: Germany (Doc Verified) - CODE CORRECTED
        nationalTrait: playerTraits_1.PlayerTraits.POWERFUL,
        bonusStat: { tackle: 1 },
    },
    [nations_1.Nations.AUSTRIA]: {
        favoredOpponent: [nations_1.Nations.GERMANY, nations_1.Nations.SWITZERLAND], // Main: Germany, Regional: Switzerland (Doc Verified) - CODE CORRECTED
        nationalTrait: playerTraits_1.PlayerTraits.UNDERDOG,
        bonusStat: { pass: 1 },
    },
    [nations_1.Nations.SWITZERLAND]: {
        favoredOpponent: [nations_1.Nations.FRANCE, nations_1.Nations.AUSTRIA], // Main: France, Regional: Austria (Doc Verified) - CODE CORRECTED
        nationalTrait: playerTraits_1.PlayerTraits.UNYIELDING,
        bonusStat: { pass: 1 },
    },
    // Northern Europe / Scandinavia Region
    [nations_1.Nations.SWEDEN]: {
        favoredOpponent: [nations_1.Nations.ENGLAND, nations_1.Nations.DENMARK], // Main: ENGLAND, Regional: Denmark (Doc Verified)
        nationalTrait: playerTraits_1.PlayerTraits.ORGANISED,
        bonusStat: { tackle: 1 },
    },
    [nations_1.Nations.DENMARK]: {
        favoredOpponent: [nations_1.Nations.NETHERLANDS, nations_1.Nations.NORWAY], // Main: Netherlands, Regional: Sweden (Doc Verified)
        nationalTrait: playerTraits_1.PlayerTraits.INSPIRE,
        bonusStat: { pass: 1 },
    },
    [nations_1.Nations.NORWAY]: {
        favoredOpponent: [nations_1.Nations.BRAZIL, nations_1.Nations.FINLAND], // Main: Brazil, Regional: Sweden (Doc Verified)
        nationalTrait: playerTraits_1.PlayerTraits.GOAL_MACHINE,
        bonusStat: { shoot: 1 },
    },
    [nations_1.Nations.FINLAND]: {
        favoredOpponent: [nations_1.Nations.DENMARK, nations_1.Nations.SWEDEN], // Main: Denmark, Regional: Sweden (Doc Verified) - CODE CORRECTED (Main was France)
        nationalTrait: playerTraits_1.PlayerTraits.DETERMINED,
        bonusStat: { intercept: 1 },
    },
    // Eastern Europe Region
    [nations_1.Nations.RUSSIA]: {
        favoredOpponent: [nations_1.Nations.SPAIN, nations_1.Nations.CROATIA], // Main: Spain, Regional: Ukraine (Doc Verified) - CODE CORRECTED (Regional was Croatia)
        nationalTrait: playerTraits_1.PlayerTraits.DOMINANT,
        bonusStat: { tackle: 1 },
    },
    [nations_1.Nations.UKRAINE]: {
        favoredOpponent: [nations_1.Nations.SWEDEN, nations_1.Nations.SERBIA], // Main: Sweden, Regional: Russia (Doc Verified) - CODE CORRECTED (Regional was Serbia)
        nationalTrait: playerTraits_1.PlayerTraits.UNYIELDING,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.SERBIA]: {
        favoredOpponent: [nations_1.Nations.GERMANY, nations_1.Nations.RUSSIA], // Main: Germany, Regional: Croatia (Doc Verified) - CODE CORRECTED (Regional was Russia)
        nationalTrait: playerTraits_1.PlayerTraits.POWERFUL,
        bonusStat: { block: 1 },
    },
    [nations_1.Nations.CROATIA]: {
        favoredOpponent: [nations_1.Nations.ENGLAND, nations_1.Nations.UKRAINE], // Main: England, Regional: Serbia (Doc Verified) - CODE CORRECTED (Regional was Ukraine)
        nationalTrait: playerTraits_1.PlayerTraits.FLAIR,
        bonusStat: { pass: 1 },
    },
    [nations_1.Nations.TURKEY]: {
        favoredOpponent: [nations_1.Nations.NETHERLANDS, nations_1.Nations.CROATIA], // Main: Netherlands, Regional: Croatia (Doc Verified) - CODE CORRECTED
        nationalTrait: playerTraits_1.PlayerTraits.IGNITE,
        bonusStat: { shoot: 1 },
    },
    // Africa Region
    [nations_1.Nations.EGYPT]: {
        favoredOpponent: [nations_1.Nations.ITALY, nations_1.Nations.MOROCCO], // Main: Italy, Regional: Algeria (Doc Verified) - CODE CORRECTED (Regional was Morocco)
        nationalTrait: playerTraits_1.PlayerTraits.PLAYMAKER,
        bonusStat: { pass: 1 },
    },
    [nations_1.Nations.NIGERIA]: {
        favoredOpponent: [nations_1.Nations.ARGENTINA, nations_1.Nations.EGYPT], // Main: Argentina, Regional: Cameroon (Doc Verified) - CODE CORRECTED (Regional was Egypt)
        nationalTrait: playerTraits_1.PlayerTraits.POWERFUL,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.SENEGAL]: {
        favoredOpponent: [nations_1.Nations.FRANCE, nations_1.Nations.NIGERIA], // Main: France, Regional: Nigeria (Doc Verified) - CODE CORRECTED (Main was Poland)
        nationalTrait: playerTraits_1.PlayerTraits.RAPID,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.MOROCCO]: {
        favoredOpponent: [nations_1.Nations.BELGIUM, nations_1.Nations.SENEGAL], // Main: Belgium, Regional: Algeria (Doc Verified) - CODE CORRECTED (Regional was Senegal)
        nationalTrait: playerTraits_1.PlayerTraits.FLAIR,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.IVORY_COAST]: {
        favoredOpponent: [nations_1.Nations.JAPAN, nations_1.Nations.GHANA], // Main: Japan, Regional: Ghana (Doc Verified) - CODE CORRECTED
        nationalTrait: playerTraits_1.PlayerTraits.POWERFUL,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.BURKINA_FASO]: {
        favoredOpponent: [nations_1.Nations.ALGERIA, nations_1.Nations.TUNISIA], // Main: Algeria, Regional: Tunisia (Doc Verified) - CODE CORRECTED
        nationalTrait: playerTraits_1.PlayerTraits.UNDERDOG,
        bonusStat: { tackle: 1 },
    },
    [nations_1.Nations.ALGERIA]: {
        favoredOpponent: [nations_1.Nations.GERMANY, nations_1.Nations.BURKINA_FASO], // Main: Germany, Regional: Burkina Faso (Doc Verified) - CODE CORRECTED (Main was S. Korea)
        nationalTrait: playerTraits_1.PlayerTraits.FLAIR,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.CAMEROON]: {
        favoredOpponent: [nations_1.Nations.ARGENTINA, nations_1.Nations.NIGERIA], // Main: Argentina, Regional: Nigeria (Doc Verified) - CODE CORRECTED
        nationalTrait: playerTraits_1.PlayerTraits.UNYIELDING,
        bonusStat: { shoot: 1 },
    },
    [nations_1.Nations.ZIMBABWE]: {
        // Note: Document lists Zambia as regional. Assuming ZAMBIA enum exists.
        favoredOpponent: [nations_1.Nations.GHANA, nations_1.Nations.ZAMBIA], // Main: Ghana (Rule Bend), Regional: Zambia (Doc Verified) - CODE CORRECTED (Regional missing)
        nationalTrait: playerTraits_1.PlayerTraits.LUCKY,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.TUNISIA]: {
        favoredOpponent: [nations_1.Nations.FRANCE, nations_1.Nations.ALGERIA], // Main: France, Regional: Algeria (Doc Verified) - CODE CORRECTED
        nationalTrait: playerTraits_1.PlayerTraits.ORGANISED,
        bonusStat: { intercept: 1 },
    },
    [nations_1.Nations.GHANA]: {
        favoredOpponent: [nations_1.Nations.URUGUAY, nations_1.Nations.IVORY_COAST], // Main: Uruguay, Regional: Ivory Coast (Doc Verified) - CODE CORRECTED
        nationalTrait: playerTraits_1.PlayerTraits.POWERFUL,
        bonusStat: { run: 1 },
    },
    // Asia Region
    [nations_1.Nations.JAPAN]: {
        favoredOpponent: [nations_1.Nations.GERMANY, nations_1.Nations.KOREA_SOUTH], // Main: Germany, Regional: South Korea (Doc Verified) - CODE CORRECTED (Main was Spain)
        nationalTrait: playerTraits_1.PlayerTraits.ORGANISED,
        bonusStat: { pass: 1 },
    },
    [nations_1.Nations.KOREA_SOUTH]: {
        favoredOpponent: [nations_1.Nations.PORTUGAL, nations_1.Nations.QATAR], // Main: Portugal, Regional: Japan (Doc Verified) - CODE CORRECTED (Regional was Qatar)
        nationalTrait: playerTraits_1.PlayerTraits.DETERMINED,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.SAUDI_ARABIA]: {
        favoredOpponent: [nations_1.Nations.ARGENTINA, nations_1.Nations.JAPAN], // Main: Argentina, Regional: Qatar (Doc Verified) - CODE CORRECTED (Regional was Japan)
        nationalTrait: playerTraits_1.PlayerTraits.POWERFUL,
        bonusStat: { tackle: 1 },
    },
    [nations_1.Nations.QATAR]: {
        favoredOpponent: [nations_1.Nations.SWITZERLAND, nations_1.Nations.SAUDI_ARABIA], // Main: Switzerland, Regional: Saudi Arabia (Doc Verified)
        nationalTrait: playerTraits_1.PlayerTraits.PLAYMAKER,
        bonusStat: { pass: 1 },
    },
    [nations_1.Nations.CHINA]: {
        favoredOpponent: [nations_1.Nations.FRANCE, nations_1.Nations.KOREA_SOUTH], // Main: France, Regional: South Korea (Doc Verified) - CODE CORRECTED
        nationalTrait: playerTraits_1.PlayerTraits.DOMINANT,
        bonusStat: { tackle: 1 },
    },
    [nations_1.Nations.INDIA]: {
        // Note: Document lists Bangladesh as regional. Assuming BANGLADESH enum exists.
        favoredOpponent: [nations_1.Nations.QATAR, nations_1.Nations.BANGLADESH], // Main: Qatar (Rule Bend), Regional: Bangladesh (Doc Verified) - CODE CORRECTED (Regional missing)
        nationalTrait: playerTraits_1.PlayerTraits.UNDERDOG,
        bonusStat: { pass: 1 },
    },
    // North America Region
    [nations_1.Nations.MEXICO]: {
        favoredOpponent: [nations_1.Nations.BRAZIL, nations_1.Nations.CANADA], // Main: Brazil, Regional: USA (Doc Verified) - CODE CORRECTED (Regional was Canada)
        nationalTrait: playerTraits_1.PlayerTraits.FLAIR,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.USA]: {
        favoredOpponent: [nations_1.Nations.ENGLAND, nations_1.Nations.MEXICO], // Main: England, Regional: Mexico (Doc Verified) - CODE CORRECTED (Main was Portugal)
        nationalTrait: playerTraits_1.PlayerTraits.POWERFUL,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.CANADA]: {
        favoredOpponent: [nations_1.Nations.USA, nations_1.Nations.COSTA_RICA], // Main: USA, Regional: Mexico (Doc Verified) - CODE CORRECTED (Main was Morocco, Regional was Costa Rica)
        nationalTrait: playerTraits_1.PlayerTraits.RAPID,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.COSTA_RICA]: {
        favoredOpponent: [nations_1.Nations.ITALY, nations_1.Nations.USA], // Main: Italy, Regional: USA (Doc Verified) - CODE CORRECTED (Main was Uruguay)
        nationalTrait: playerTraits_1.PlayerTraits.UNDERDOG,
        bonusStat: { intercept: 1 },
    },
    // Uruguay moved to South America Region as per document hierarchy
    // Caribbean Region
    [nations_1.Nations.JAMAICA]: {
        favoredOpponent: [nations_1.Nations.MEXICO, nations_1.Nations.TRINIDAD_AND_TOBAGO], // Main: Mexico, Regional: USA (Doc Verified) - CODE CORRECTED (Regional was T&T)
        nationalTrait: playerTraits_1.PlayerTraits.RAPID,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.TRINIDAD_AND_TOBAGO]: {
        favoredOpponent: [nations_1.Nations.USA, nations_1.Nations.HAITI], // Main: USA, Regional: Mexico (Doc Verified) - CODE CORRECTED (Regional was Haiti)
        nationalTrait: playerTraits_1.PlayerTraits.FLAIR,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.HAITI]: {
        favoredOpponent: [nations_1.Nations.ITALY, nations_1.Nations.CUBA], // Main: Italy, Regional: Jamaica (Doc Verified) - CODE CORRECTED (Main was Mexico, Regional was Cuba)
        nationalTrait: playerTraits_1.PlayerTraits.DETERMINED,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.CUBA]: {
        favoredOpponent: [nations_1.Nations.USA, nations_1.Nations.JAMAICA], // Main: USA, Regional: Haiti (Doc Verified) - CODE CORRECTED (Main was Costa Rica, Regional was Jamaica)
        nationalTrait: playerTraits_1.PlayerTraits.UNDERDOG,
        bonusStat: { tackle: 1 },
    },
    // South America Region
    [nations_1.Nations.BRAZIL]: {
        favoredOpponent: [nations_1.Nations.ITALY, nations_1.Nations.COLOMBIA], // Main: ITALY, Regional: Argentina (Doc Verified) - CODE CORRECTED (Main was Spain, Regional was Colombia)
        nationalTrait: playerTraits_1.PlayerTraits.STAR,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.ARGENTINA]: {
        favoredOpponent: [nations_1.Nations.ENGLAND, nations_1.Nations.BRAZIL], // Main: England, Regional: Brazil (Doc Verified)
        nationalTrait: playerTraits_1.PlayerTraits.CHARGE,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.URUGUAY]: {
        // Moved from North America region based on Doc
        favoredOpponent: [nations_1.Nations.BRAZIL, nations_1.Nations.ARGENTINA], // Main: Brazil, Regional: Argentina (Doc Verified) - CODE CORRECTED
        nationalTrait: playerTraits_1.PlayerTraits.DETERMINED,
        bonusStat: { tackle: 1 },
    },
    [nations_1.Nations.COLOMBIA]: {
        favoredOpponent: [nations_1.Nations.ARGENTINA, nations_1.Nations.CHILE], // Main: Argentina, Regional: Brazil (Doc Verified) - CODE CORRECTED (Main was Poland, Regional was Chile)
        nationalTrait: playerTraits_1.PlayerTraits.FLAIR, // Corrected based on Doc
        bonusStat: { tackle: 1 },
    },
    [nations_1.Nations.CHILE]: {
        favoredOpponent: [nations_1.Nations.SPAIN, nations_1.Nations.ARGENTINA], // Main: Spain, Regional: Argentina (Doc Verified)
        nationalTrait: playerTraits_1.PlayerTraits.DETERMINED,
        bonusStat: { tackle: 1 },
    },
    // Oceania Region
    [nations_1.Nations.AUSTRALIA]: {
        favoredOpponent: [nations_1.Nations.URUGUAY, nations_1.Nations.NEW_ZEALAND], // Main: Uruguay, Regional: NZ (Doc Verified)
        nationalTrait: playerTraits_1.PlayerTraits.POWERFUL,
        bonusStat: { tackle: 1 },
    },
    [nations_1.Nations.NEW_ZEALAND]: {
        favoredOpponent: [nations_1.Nations.ITALY, nations_1.Nations.FIJI], // Main: Italy, Regional: Australia (Doc Verified) - CODE CORRECTED (Regional was Fiji)
        nationalTrait: playerTraits_1.PlayerTraits.UNDERDOG,
        bonusStat: { intercept: 1 },
    },
    [nations_1.Nations.FIJI]: {
        // Main: NZ (Bend rule - regional), Regional: Solomon Islands (Doc Verified)
        favoredOpponent: [nations_1.Nations.NEW_ZEALAND, nations_1.Nations.SOLOMON_ISLANDS],
        nationalTrait: playerTraits_1.PlayerTraits.RAPID,
        bonusStat: { run: 1 },
    },
    [nations_1.Nations.SOLOMON_ISLANDS]: {
        // Main: Fiji (Bend rule - regional), Regional: Australia (Doc Verified)
        favoredOpponent: [nations_1.Nations.FIJI, nations_1.Nations.AUSTRALIA],
        nationalTrait: playerTraits_1.PlayerTraits.LUCKY, // Doc Verified
        bonusStat: { run: 1 }, // Corrected from flair: 1 based on Doc review - Doc actually says Flair. Reverting.
    },
    // Southern Europe Region (Consolidated)
    [nations_1.Nations.GREECE]: {
        favoredOpponent: [nations_1.Nations.FRANCE, nations_1.Nations.PORTUGAL], // Main: France, Regional: Turkey (Doc Verified) - CODE CORRECTED (Regional was Portugal)
        nationalTrait: playerTraits_1.PlayerTraits.UNYIELDING,
        bonusStat: { intercept: 1 },
    },
    [nations_1.Nations.PORTUGAL]: {
        favoredOpponent: [nations_1.Nations.NETHERLANDS, nations_1.Nations.SPAIN], // Main: Netherlands, Regional: Spain (Doc Verified) - CODE CORRECTED (Main was England)
        nationalTrait: playerTraits_1.PlayerTraits.FLAIR,
        bonusStat: { shoot: 1 },
    },
    [nations_1.Nations.ITALY]: {
        favoredOpponent: [nations_1.Nations.FRANCE, nations_1.Nations.GREECE], // Main: Germany, Regional: France (Doc Verified) - CODE CORRECTED (Regional was Greece)
        nationalTrait: playerTraits_1.PlayerTraits.ORGANISED,
        bonusStat: { intercept: 1 },
    },
    [nations_1.Nations.SPAIN]: {
        favoredOpponent: [nations_1.Nations.NETHERLANDS, nations_1.Nations.ITALY], // Main: Netherlands, Regional: Portugal (Doc Verified) - CODE CORRECTED (Regional was Italy)
        nationalTrait: playerTraits_1.PlayerTraits.TIKI_TAKA,
        bonusStat: { pass: 1 },
    },
};
// Function remains the same as user provided
function getNationData(nation) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    return exports.NationDetails[nation] || exports.DefaultNationData; // Added non-null assertion as keys should exist
}
// Updated to use NationalLevel enum
function calculateNationalBonus(nation, nationalLevel = NationalLevel.BASIC) {
    const nationData = getNationData(nation);
    const bonus = {
        statBlock: nationData.bonusStat,
        positionsEnabled: [],
        playerTraits: [],
        preferredOpponent: nationData.favoredOpponent,
    };
    if (nationalLevel === NationalLevel.HERO ||
        nationalLevel === NationalLevel.ICON) {
        bonus.playerTraits.push(nationData.nationalTrait);
    }
    if (nationalLevel === NationalLevel.ICON) {
        bonus.playerTraits.push(playerTraits_1.PlayerTraits.ICON);
    }
    return bonus;
}
